import React from 'react';

import defaultAvatar from '../UserAvatar/default.svg';
import styles from './CreatorRow.module.scss';

type CreatorRowProps = {
  username: string; // with leading "@"
  avatarImageUrl: string;
  title: string;
  onFollow?: () => void;
};

export default function CreatorRow({
  username,
  avatarImageUrl,
  title,
  onFollow,
}: CreatorRowProps) {
  const showFollow = Boolean(onFollow && username);

  return (
    <div className={styles.creatorRow}>
      <div className={styles.header}>
        <div
          className={styles.avatar}
          style={{
            backgroundImage: `url(${avatarImageUrl}), url(${defaultAvatar})`,
          }}
          aria-hidden
        />
        <span className={styles.username}>{username}</span>
        {showFollow && (
          <button
            type="button"
            className={styles.follow}
            onClick={onFollow}
          >
            Follow
          </button>
        )}
      </div>
      {title && <p className={styles.title}>{title}</p>}
    </div>
  );
}
